module.exports = __webpack_public_path__ + "815d218986b92ae8eb257ea884334cfc.png";